<div class="loop-stimuli">
  <div class="loop-stimuli__header">
    <h2 class="text__sm fw__600">
      <span>Stimuli</span>
      @if (media$().length) {
        <span class="loop-stimuli__count text__xs fw__400 caption" data-testid="loop-stimuli-count">{{ media$().length }}</span>
      }
    </h2>
    @if (media$().length) {
      <eiq-button text="Add stimuli" [icon]="faPlus" [style]="'stroked'" color="light" testId="loop-stimuli-add" (clicked)="onAdd()" />
    }
  </div>
  @if (media$().length) {
    <div class="loop-stimuli__strip">
      @for (row of thumbnails$(); track row.media.mediaId) {
        <div class="loop-stimuli__thumbnail" [attr.data-testid]="'loop-stimulus-' + row.media.mediaId">
          <empathy-shared-stimulus [stimulus]="row.preview" [readonly]="true" [width]="82" [height]="82" />
          @if (row.isVideo) {
            <span class="loop-stimuli__play text__sm" aria-hidden="true"><fa-icon [icon]="faPlay" /></span>
          }
          <span class="loop-stimuli__id text__xs fw__600">{{ row.media.sourceIndex | number: '3.0-0' }}</span>
          <span class="loop-stimuli__name text__xs" [title]="row.media.name">{{ row.media.name }}</span>
        </div>
      }
      @if (media$().length) {
        <button type="button" class="loop-stimuli__view-all" data-testid="loop-stimuli-view-all-button" (click)="onViewAll()">
          @if (remainingCount$()) {
            <span class="text__sm fw__600">+{{ remainingCount$() }}</span>
          }
          <span class="text__xs caption">View all</span>
        </button>
      }
    </div>
  } @else {
    <eiq-file-uploader
      class="loop-stimuli__upload"
      testId="loop-stimuli-upload"
      [acceptedTypes]="acceptedTypes"
      [acceptedTypesText]="acceptedTypesText"
      [maxSize]="maxFileSize"
      [multiple]="true"
      (uploaded)="onUpload($event)"
    />
  }
</div>
